import React, { useState, useEffect } from "react";
import { FaEnvelope, FaPhone, FaFacebook } from "react-icons/fa";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import "./Footer.css";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export default function Footer() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    website: "", // honeypot
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    async function fetchFooterData() {
      try {
        const docRef = doc(db, "settings", "basicInfo");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) setContactInfo(docSnap.data());
      } catch (err) {
        console.error("Failed to load contact info", err);
      }
    }
    fetchFooterData();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (form.website) return; // honeypot
  if (!form.name.trim() || !form.email.trim() || !form.message.trim()) return;

  // Build the "to" list directly from the loaded doc each time (like Contact.js)
  const toList = (contactInfo?.notificationEmails || [])
    .filter(Boolean)
    .map(e => e.trim())
    .filter(e => e.length > 0)
    .join(", ");

  if (!toList) {
    alert("Recipients are not loaded yet. Please try again in a moment.");
    return;
  }

  const templateParams = {
    from_name: form.name,
    reply_email: form.email.trim(),
    phone_number: form.phone.trim(),
    message: form.message,
    email: toList,                        // same field name Contact.js uses
    phone_row_style: form.phone.trim() ? "" : "display:none;",
    email_row_style: form.email.trim() ? "" : "display:none;",
  };

  setSending(true);
  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
    setSent(true);
    setForm({ name: "", email: "", phone: "", message: "", website: "" });
    setTimeout(() => setSent(false), 3500);
  } catch (err) {
    console.error("EmailJS error:", err);
    alert("Sorry, we could not send your message. Please try again later.");
  } finally {
    setSending(false);
  }
};



  const formatPhone = (phone) => {
    const cleaned = phone.replace(/\D/g, "");
    return cleaned.length === 10
      ? `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
      : phone;
  };

  return (
    <footer className="footer-section">
      <div className="footer-connect">
        <div className="footer-header">
          <FaEnvelope className="footer-main-icon" />
          <h2>Let’s Connect</h2>
        </div>
        <p className="footer-lead">
          Still have questions? Cary is always happy to help.<br />
          Send a message below or reach out directly, every family is welcome!
        </p>

        <div className="footer-contact-card">
          <form className="footer-form" onSubmit={handleSubmit}>
            {/* honeypot */}
            <input
              type="text"
              name="website"
              value={form.website}
              onChange={handleChange}
              style={{ display: "none" }}
              tabIndex={-1}
              autoComplete="off"
            />

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone (optional)"
              value={form.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows={3}
              value={form.message}
              onChange={handleChange}
              required
            />
            <button type="submit" disabled={sending}>
              {sending ? "Sending..." : sent ? "Message Sent" : "Send Message"}
            </button>
            {sent && (
              <p className="sent-message" role="status">
                Thanks for reaching out. We will be in touch soon.
              </p>
            )}
          </form>

          {contactInfo && (
            <div className="footer-contact-info">
              {contactInfo.email && (
                <div>
                  <FaEnvelope className="footer-icon" />
                  <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                </div>
              )}
              {contactInfo.phone && (
                <div>
                  <FaPhone className="footer-icon" />
                  <a href={`tel:${contactInfo.phone}`}>{formatPhone(contactInfo.phone)}</a>
                </div>
              )}
              {contactInfo.facebook && (
                <div className="footer-social">
                  <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer">
                    <FaFacebook />
                  </a>
                </div>
              )}
              {contactInfo.phone && (
                <a href={`tel:${contactInfo.phone}`} className="footer-call-cta">
                  <FaPhone /> Call Now
                </a>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="footer-links-bar">
        <Link to="/">Home</Link>
        <Link to="/puppies">Available Puppies</Link>
        <Link to="/studs">Studs</Link>
        <Link to="/about">About Cary</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} DeClerck’s Goldens. All rights reserved.
      </div>
    </footer>
  );
}